module.exports = __webpack_public_path__ + "img/Weapon_240.30b906be.png";